import type { JSX } from 'preact';
import { X } from 'lucide-preact';

const CLOSE_ICON_SIZE = 20;
const CLOSE_ICON_STROKE = 2.25;

/** Icon-only dismiss control for floating panes and other overlay chrome. */
export function CloseButton({
  onClick,
  label = 'Close',
}: {
  onClick: () => void;
  label?: string;
}): JSX.Element {
  return (
    <button type="button" class="ui-close" aria-label={label} onClick={onClick}>
      <X size={CLOSE_ICON_SIZE} strokeWidth={CLOSE_ICON_STROKE} aria-hidden="true" />
    </button>
  );
}
